import {CrudModel} from '@ngx-ivengi/crud';
import { priceType } from './price.enum';

export class Price extends CrudModel {
  public file: FileList;
  public fileId: string;
  public fileName: string;
  public mappingVersion: number = 2;
  public priceType: priceType;
  public fileSrc: string = '';
  public createdDate: Date;

  public setFile(files: FileList): Price {
    if(files instanceof FileList) {
      this.file = files;
    }
    return this;
  }

  public setFileId(fileId: string): Price {
    if(typeof fileId === 'string') {
      this.fileId = fileId;
    }
    return this;
  }

  public setFileName(fileName: string): Price {
    if(typeof fileName === 'string') {
      this.fileName = fileName;
    }
    return this;
  }

  public setMappingVersion(mappingVersion: number): Price {
    if (typeof mappingVersion === 'number') {
      this.mappingVersion = mappingVersion;
    }
    return this;
  }

  public setFileSrc(fileSrc: string): Price {
    if(typeof fileSrc === 'string') {
      this.fileSrc = fileSrc;
    }
    return this;
  }

  public setPriceType(priceType: priceType): Price {
    if (typeof priceType === 'string') {
      this.priceType = priceType;
    }
    return this;
  }

  public setCreatedDate(created: Date): Price {
    if(created instanceof Date) {
      this.createdDate = created;
    }
    return this;
  }

  fromResponse(response: any): void {
    this
      .setId(response.id);

    if(response.file) {
      this
        .setFileId(response.file.id)
        .setFileName(response.file.name)
        .setFileSrc(response.file.src)
        .setPriceType(response.priceType)
        .setMappingVersion(response.mappingVersion)
        .setCreatedDate(new Date(response.createdDate));
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/price/price.model.ts